import axios from "axios";

export function getStsQuestions(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "StsQuestion/getlist", config);
}

export function getEvaluateStage(data) {
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentStsResult/evaluateStage", data);
}
